import React, { useEffect, useState } from 'react'
import styles from "./SingleReportsDetails.module.scss"
import { useSelector } from 'react-redux'
import ReportsTable from './ReportsTable'
import { FORM_RESPONSE, LOCATION, REPORT } from 'services/apiEndpoints'
import toast from 'react-hot-toast'
import { privateGet, privatePost } from 'services/privateRequest'
import { useParams } from 'react-router-dom'
import MapWithStreetView from './MapStreetView'
import Button from 'components/shared/button/Button'
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { Popover, TextField } from '@mui/material'
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const SingleReportDetails = () => {
    const { id, formId } = useParams()
    const { formName } = useSelector((state) => state?.global)
    const [loader, setLoader] = useState(false)
    const [submitterGeoCoordinates, setSubmitterGeoCoordinates] = useState({})
    const [copied, setCopied] = useState(false);
    const [value, setValue] = useState(`${window.location.origin}/share/${formName?.replaceAll("/", "|") || "Sample Report"}/${id}`)

    const [data, setData] = useState({})
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [openDialogue, setOpenDailogue] = React.useState(false);
    const open = Boolean(anchorEl);
    const ids = open ? 'simple-popover' : undefined;
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const modifiedPayload = (data) => {
        let finalPayload = {
            data: {
                name: formName || "",
                submittedBy: `${data?.userId?.firstName} ${data?.userId?.lastName}`,
                fields: data?.fields?.length ? data?.fields?.map((field) => {
                    return {
                        fieldId: field?.fieldId,
                        type: field?.type,
                        mediaResponse: field?.mediaResponse?.length ? field?.mediaResponse : [],
                        label: field?.label,
                        value: field?.value || [],
                        dependentField: field?.dependentField?.length ? field?.dependentField?.map((field) => {
                            return {
                                fieldId: field?.fieldId,
                                label: field?.label,
                                value: field?.value || [],
                                type: field?.type,
                                mediaResponse: field?.mediaResponse?.length ? field?.mediaResponse : [],

                            }
                        }) : []
                    }
                }) : [],
                sections: data?.sections?.length ? data?.sections?.map((section) => {
                    return {
                        sectionId: section?.sectionId,
                        name: section?.name,
                        fields: section?.fields?.length ? section?.fields?.map((field) => {
                            return {
                                fieldId: field?.fieldId,
                                label: field?.label,
                                value: field?.value || [],
                                type: field?.type,
                                mediaResponse: field?.mediaResponse?.length ? field?.mediaResponse : [],
                                dependentField: field?.dependentField?.length ? field?.dependentField?.map((field) => {
                                    return {
                                        fieldId: field?.fieldId,
                                        label: field?.label,
                                        value: field?.value || [],
                                        type: field?.type,
                                        mediaResponse: field?.mediaResponse?.length ? field?.mediaResponse : [],

                                    }
                                }) : []
                            }
                        }) : []
                    }
                }) : []
            }
        }
        return finalPayload
    }
    const handlePdf = async (type) => {
        setAnchorEl(null);
        try {
            if (type === "email") {
                let res = await privatePost(`${REPORT}/pdf/${formId}?type=${type}`, modifiedPayload(data));
                if (res?.data?.success) {
                    toast?.success(res?.data?.message);
                }
            } else {
                // toast.promise(
                    
                //     privatePost(`${REPORT}/pdf/${formId}?type=${type}`, modifiedPayload(data))
                //         .then((res) => {

                //             const toastId = toast.loading("Generating your PDF...", {
                //                 position: "top-center",
                //                 style: {
                //                   maxWidth: "600px"
                //                 },
                //                 icon: false, // optional
                //               });

                //             if (res?.data?.success) {
                //                 const url = res.data.data?.trim()
                //                 const link = document.createElement("a");
                //                 link.href = url;
                //                 link.target = "_blank";
                //                 link.rel = "noopener noreferrer";
                //                 document.body.appendChild(link);
                               
                //                 setTimeout(() => {
                //                     link.click();
                //                     document.body.removeChild(link);
                //                 }, 500); 
                //                 toast.success("PDF generated successfully!", {
                //                     id: toastId,
                //                   });
                //                 } else {
                //                   toast.error("Could not generate PDF.", {
                //                     id: toastId,
                //                   });
                //             }
                //         }),
                //     //     {
                //     //         loading: {
                //     //           render() {
                //     //             return <b>I'm loading</b>; // ✅ JSX, no quotes inside <b>
                //     //           },
                //     //           icon: false, // ✅ removes spinner
                //     //         },
                //     //         success: {
                //     //           render() {
                //     //             return <b>PDF generated successfully!</b>;
                //     //           },
                //     //         },
                //     //         error: {
                //     //           render() {
                //     //             return <b>Could not generate PDF.</b>;
                //     //           },
                //     //         },
                //     //       },
                //     // {
                //     //     position: "top-center",
                //     //     style:{
                //     //         maxWidth:"600px"
                //     //     }
                //     // }
                    
                // );
                const toastId = toast.loading(<b>Your PDF is Generating...</b>, {
                    position: "top-center",
                    style: {
                      maxWidth: "600px",
                    },
                    icon: false,
                    duration: 2000
                  });
                  
                  privatePost(`${REPORT}/pdf/${formId}?type=${type}`, modifiedPayload(data))
                    .then((res) => {
                      if (res?.data?.success) {
                        const url = res.data.data?.trim();
                        const link = document.createElement("a");
                        link.href = url;
                        link.target = "_blank";
                        link.rel = "noopener noreferrer";
                        document.body.appendChild(link);
                  
                        setTimeout(() => {
                          link.click();
                          document.body.removeChild(link);
                        }, 500);
                  
                    //     toast.success("PDF generated successfully!", { id: toastId });
                    //   } else {
                    //     toast.error("Could not generate PDF.", { id: toastId });
                    //   }
                      }
                    })
                    .catch(() => {
                      toast.error("Could not generate PDF.", { id: toastId });
                    });
                  
            }
        } catch (err) {
            toast?.error(err?.message || 'Something went wrong while generating the PDF.');
            setLoader(false);
        }
    }
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleCloseDailogue = () => {
        setOpenDailogue(false)
    }

    const handleCopy = () => {
        navigator.clipboard.writeText(value || "test").then(() => {
            setOpenDailogue(false)
            setCopied(true)
            toast?.success("Link Copied to Clipboard!")
        });
    };
    const handleChange = (value) => {
        setValue(value)
    }


    const fetchData = async () => {
        try {
            setLoader(true);
            const response = await privateGet(`${FORM_RESPONSE}/${id}`);
            const responseData = response?.data?.data;

            let location = responseData?.sections?.find(section =>
                section?.fields?.some(f => f.type === "Location" && f.value?.length > 0)
            )?.fields?.find(f => f.type === "Location" && f.value?.length > 0) ||
                responseData?.fields?.find(f => f.type === "Location" && f.value?.length > 0);

            if (location?._id) {
                const res = await privateGet(`${LOCATION}?search=${location?.value[0]}`);
                const locationRes = res?.data?.data?.location[0];
                setSubmitterGeoCoordinates({
                    latitude: Number(locationRes?.latitude),
                    longitude: Number(locationRes?.longitude),
                    address: locationRes?.address
                });
            } else {
                setSubmitterGeoCoordinates({});
            }
            setData(responseData);
            setLoader(false);
        } catch (err) {
            setLoader(false);
            toast?.error(err?.message);
        } finally {
            setLoader(false);
        }
    };
    
    useEffect(() => {
        fetchData()
    }, [])
    return (
        <>
            <div className={styles?.mainSingleReport}>
                <ReportsTable data={data} setData={setData} loader={loader} formName={formName} />
                <div className={styles?.mapContainer}>
                    <Button onClick={handleClick} style={{ display: "flex", alignItems: "center", gap: "5px", marginLeft: "auto" }}>
                        <FileDownloadIcon />
                        Export</Button>
                    <MapWithStreetView location={data?.location} submitter={data?.userId} timeToComplete={data?.timeToComplete} submitterGeoCoordinates={submitterGeoCoordinates} loader={loader} />
                </div>
            </div >
            <Popover
                id={ids}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <div className={styles?.exportOptions}>
                    <ul>
                        <li onClick={() => handlePdf("pdf")}>PDF</li>
                        <li onClick={() => handlePdf("email")}>Email PDF</li>
                        <li onClick={() => {
                            setOpenDailogue(true)
                            setAnchorEl(null)

                        }}>Share Link</li>

                    </ul>
                </div>
            </Popover>
            <Dialog
                onClose={handleCloseDailogue}
                aria-labelledby="customized-dialog-title"
                open={openDialogue}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Share Link
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleCloseDailogue}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <p style={{ fontWeight: "bolder" }}>
                        Share this link with your partners, clients, or customers.
                    </p>
                    <TextField
                        fullWidth
                        value={value}
                        onChange={(e) => handleChange(e?.target?.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleCopy}>
                        {copied ? "Copied!" : "Copy link to Clipboard"}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default SingleReportDetails